




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PGRowElementSelect from './PGRowElementSelect.vue';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';

@Component({
  components: {
    PGRowElementSelect
  }
})
export default class PGRowAPPValue extends Vue {
  @Prop() private value!: string;
  @Prop() private isEditable!: boolean;

  valueChanged(newValue: string, newElement: BaseElement): void {
    this.$emit('valueChanged', newValue, newElement);
  }

  get options() {
    return this.$store.state.ModuleMD.apps;
  }
}
